import Button from './Button'

const FeatureNews = ({
  title,
  excerpt,
  ctaText,
  ctaLink,
  img,
  order,
  position
}) => {
  return (
    <div
      className={`grid lg:grid-cols-2 mt-4 lg:mt-0 lg:min-h-[700px] ${
        !order ? 'bg-sec-grey-4' : 'bg-grey'
      }`}
    >
      {order === 'Imagen y Texto' ? (
        <>
          <div
            className={`bg-cover h-[300px] sm:h-[400px] lg:h-full ${
              position ? `bg-${position}` : ''
            }`}
            style={{
              backgroundImage: `url(
                    ${img}
                  )`
            }}
          />
          <div className="w-full py-10 lg:py-24 text-left px-4 sm:px-8 lg:px-16">
            <h1 className="text-4xl font-alliance-medium tracking-tight text-blue sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl lg:mr-24">
              <span className="block xl:inline">{title}</span>
            </h1>
            <p className="mt-8 font-alliance max-w-md text-blue text-xl sm:text-lg md:mt-5 md:max-w-3xl">
              {excerpt}
            </p>
            {ctaText && (
              <div className="mt-16">
                <Button link={ctaLink} text={ctaText} />
              </div>
            )}
          </div>
        </>
      ) : (
        <>
          <div className="order-2 lg:order-1 w-full py-10 lg:py-24 text-left px-4 sm:px-8 lg:px-16">
            <h1 className="text-4xl font-alliance-medium tracking-tight text-blue sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl lg:mr-24">
              <span className="block xl:inline">{title}</span>
            </h1>
            <p className="mt-8 font-alliance max-w-md text-blue text-lg lg:text-xl md:mt-16 md:max-w-3xl">
              {excerpt}
            </p>
            {ctaText && (
              <div className="mt-16">
                <Button link={ctaLink} text={ctaText} />
              </div>
            )}
          </div>
          <div className="order-1 lg:order-2">
            <div
              className={`bg-cover h-[300px] sm:h-[400px] lg:h-full ${
                position ? `bg-${position}` : ''
              }`}
              style={{
                backgroundImage: `url(
                    ${img}
                  )`
              }}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default FeatureNews
